import Vue from "vue";
import { LOGOUT, CHECK_AUTHENTICATION, LOGIN } from "./../../mutation-types";

export default {
  [CHECK_AUTHENTICATION](state) {
    if (!navigator.cookieEnabled) {
      // toastr.error(this._vm.$t('modal.no_cookies')); //TODO: !!!
      switch (this._vm.$lang) {
        case "en":
          toastr.error("Please allow cookies from your browser settings");
          break;
        case "pt":
          toastr.error("Permita cookies");
          break;
        case "es":
          toastr.error("Por favor permita las cookies");
          break;
        default:
          toastr.error("Veuillez autoriser les cookies");
          break;
      }
      // toastr.error(this._vm.$t('modal.no_cookies'));
      // toastr.error(this._vm.$t('modal.no_cookies'));
      return;
    }
    state.authenticated = !!localStorage.getItem("id_token");
    if (state.authenticated) {
      Vue.$http.defaults.headers.common.Authorization = `${localStorage.getItem(
        "id_token"
      )}`;
    }
  },

  [LOGIN](state, data) {
    let token = data.token;
    state.authenticated = true;
    localStorage.setItem("id_token", "Bearer " + token);
    Vue.$http.defaults.headers.common.Authorization = "Bearer " + `${token}`;
  },

  [LOGOUT](state) {
    state.authenticated = false;
    localStorage.removeItem("id_token");
    Vue.$http.defaults.headers.common.Authorization = "";
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/mutations.js